import axios from 'axios';
import router from '../../router';

export const moduleLogin = {
	state() {
		return {
			user: null,
			isDocumentExpired: false,
			//Loader
			userDataLoader: false,
			modalOwk: false,
			ssoModal: false,
			daysToEndOfMigration: 0,
			// Pokazywanie/ukrywanie platnosci - appsettings - Start
			showMTransfer: true,
			showPaynow: true,
			loginLoader: false,

			logOutTimerId: null,

			canEditClientData: true,

			showCanEditClientDataModal: false,
		};
	},
	mutations: {
		setUser(state, userData) {
			state.user = userData;
		},
		clearAuthenticationData(state) {
			state.user = null;
		},
		setShowPoolInformationDialog(state, value) {
			if (state.user) {
				state.user.showPoolInformationDialog = value;
			}
		},
		setDocumentExpired(state, value) {
			state.isDocumentExpired = value;
		},
		setShowValidateDataDialog(state, value) {
			state.user.showValidateDataDialog = value;
		},
		//Loader
		setUserDataLoader(state, value) {
			state.userDataLoader = value;
		},
		setModalOwk(state, value) {
			state.modalOwk = value;
		},
		setShowMTransfer(state, value) {
			state.showMTransfer = value;
		},
		setShowPaynow(state, value) {
			state.showPaynow = value;
		},
		setLoginLoader(state, value) {
			state.loginLoader = value;
		},
		setLogOutTimerId(state, value) {
			state.logOutTimerId = value;
		},
		setShowSsoModal(state, value) {
			state.ssoModal = value;
		},
		setAmountOfDaysLeft(state, value) {
			state.daysToEndOfMigration = value;
		},
		setCanEditClientData(state, value) {
			state.canEditClientData = value;
		},
		setShowCanEditClientDataModal(state, value) {
			state.showCanEditClientDataModal = value;
		},
	},
	actions: {
		logIn({ commit, dispatch, getters }, authData) {
			var obj = {
				Login: authData.Login,
				Password: authData.Password,
			};

			commit('setGlobalErrorMessage', '');
			commit('setLoginLoader', true);
			commit('setErrorCode', '');

			axios
				.post('account/login', obj, { withCredentials: true })
				.then(
					(response) => {
						const now = new Date();
						const expirationDate = new Date(
							now.getTime() + getters.getTimeToLogout
						);

						commit(
							'setDocumentExpired',
							response.data.isDocumentExpired
						);

						sessionStorage.setItem(
							'expirationDate',
							expirationDate
						);
						return response;
					},
					(response) => {
						if (response.status === 401) {
							var information = response.bodyText;
							if (!information) {
								information =
									'Podana nazwa użytkownika lub hasło są nieprawidłowe';
							}
							commit('setGlobalErrorMessage', information);
						} else if (response.status === 400) {
							commit(
								'setGlobalErrorMessage',
								'Musisz podać nazwę użytkownika<br>Musisz podać hasło.'
							);
						} else {
							if (
								response.data &&
								response.data.errorStrongName
							) {
								commit(
									'setErrorCode',
									response.data.errorStrongName
								);
							} else {
								commit(
									'setGlobalErrorMessage',
									'Wystąpił błąd. Sróbuj ponownie później.'
								);
							}
						}
						return response;
					}
				)
				.then(async (response) => {
					if (response) {
						await router.push('/Dashboard');
						dispatch('fetchLogOutTimer', getters.getTimeToLogout);
					}
				})
				.finally(() => {
					commit('setLoginLoader', false);
				});
		},
		async autoLogIn({ dispatch, getters }) {
			dispatch('newLogoutTime');

			await Promise.all([
				dispatch('fetchBankAccountList'),
				dispatch('fetchPayout'),
				dispatch('fetchUserData'),
				dispatch('fetchLogOutTimer', getters.getTimeToLogout),
				dispatch('fetchTrainingList'),
				dispatch('fetchInternalSettings'),
			]);
		},
		fetchUserData({ commit }) {
			commit('setUserDataLoader', true);
			axios.get('Client/Start').then(
				(response) => {
					commit('setUser', response.data);
					commit('setModalOwk', response.data.showValidateDataDialog);
					commit('setUserDataLoader', false);
					commit('setShowMTransfer', response.data.showMTransfer);
					commit('setShowPaynow', response.data.showPaynow);
					commit(
						'setShowSsoModal',
						response.data.migrationData
							? response.data.migrationData.showMigrationInfo
							: false
					);
					commit(
						'setAmountOfDaysLeft',
						response.data.migrationData
							? response.data.migrationData.daysToEndOfMigration
							: 0
					);
					commit(
						'setCanEditClientData',
						response.data.migrationData
							? response.data.migrationData.canEditClientData
							: true
					);
				},
				(response) => {
					if (response.status === 401) {
						commit('clearAuthenticationData');
						router.push('/Login');
					}
				}
			);
		},
		logOut({ dispatch }, { dontRedirect = false, redirectUrl = '' } = {}) {
			if (
				!router.currentRoute.value.fullPath
					.toLowerCase()
					.includes('login')
			) {
				axios.post('account/logout', '').then(() => {
					if (dontRedirect && redirectUrl) {
						router.replace({ name: 'login' }).then(() => {
							dispatch('clearUserData');
							window.location.href = redirectUrl;
						});
					} else {
						dispatch('clearUserData');
					}
				});
			} else {
				dispatch('clearUserData');
			}
		},
		newLogoutTime({ getters }) {
			const now = new Date();
			const expirationDate = new Date(
				now.getTime() + getters.getTimeToLogout
			);
			sessionStorage.setItem('expirationDate', expirationDate);
		},
		automatLogOut({ dispatch }) {
			let now = new Date();
			let time = new Date(sessionStorage.getItem('expirationDate'));
			let check = time - now;

			if (check > 0) {
				dispatch('fetchLogOutTimer', check);
			} else {
				dispatch('logOut');
			}
		},
		fetchLogOutTimer({ state, commit, dispatch }, expirationTime) {
			if (state.logOutTimerId !== null) {
				clearTimeout(state.logOutTimerId);
			}

			const timerId = setTimeout(() => {
				dispatch('automatLogOut');
			}, expirationTime);

			commit('setLogOutTimerId', timerId);
		},
		fetchRefreshToken({ dispatch }) {
			return axios.get(`account/refresh-token`).then(() => {
				dispatch('newLogoutTime');
			});
		},
		clearUserData({ commit }, dontRedirect = false) {
			commit('setCurrentUser', null);
			commit('setUser', null);
			commit('setUserDataLoader', false);
			commit('clearAuthenticationData');
			commit('setGlobalSuccessMessage', '');
			commit('setGlobalErrorMessage', '');
			//dodane
			commit('setLearningModal', false);
			//
			sessionStorage.removeItem('expirationDate');
			sessionStorage.removeItem('currentPage');

			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const params = {
				errorCode: urlParams.get('errorCode') || undefined,
				s: 'v',
			};
			if (!dontRedirect) router.push({ name: 'login', query: params });
		},
	},
	getters: {
		getUser: (state) => state.user,
		getModalOwk: (state) => state.modalOwk,
		getDocumentExpired: (state) => state.isDocumentExpired,
		//Loader
		getUserDataLoader: (state) => state.userDataLoader,
		getShowMTransfer: (state) => state.showMTransfer,
		getShowPaynow: (state) => state.showPaynow,
		getLoginLoader: (state) => state.loginLoader,
		getRefreshToken: (state) => state.refreshToken,
		getLogOutTimerId: (state) => state.logOutTimerId,
		getShowSsoModal: (state) => state.ssoModal,
		getAmountOfDaysLeft: (state) => state.daysToEndOfMigration,
		getCanEditClientData: (state) => state.canEditClientData,
		getShowCanEditClientDataModal: (state) =>
			state.showCanEditClientDataModal,
	},
};
